/**
 * Generated from ch9_p01.fla
 */
export function ch9_p01(this: Ich9_p01) {
	const bg = this.bg;
	ch9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const hollyBack = this.hollyBack;
	ch9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_holly.call(this.hollyBack);
	hollyBack.x = 864;
	hollyBack.y = 516.75;
	hollyBack.width = 360.00;
	hollyBack.height = 502.50;
	hollyBack.alpha = 1.00;
	if (hollyBack.onLayout) hollyBack.onLayout();
	const fence = this.fence;
	ch9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_fence.call(this.fence);
	fence.x = 832;
	fence.y = 653;
	fence.width = 1664.00;
	fence.height = 230.00;
	fence.alpha = 1.00;
	if (fence.onLayout) fence.onLayout();
	const hollyMiddle = this.hollyMiddle;
	ch9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_hollymiddle.call(this.hollyMiddle);
	hollyMiddle.x = 947;
	hollyMiddle.y = 547;
	hollyMiddle.width = 192.00;
	hollyMiddle.height = 70.00;
	hollyMiddle.alpha = 1.00;
	if (hollyMiddle.onLayout) hollyMiddle.onLayout();
	const lamb = this.lamb;
	ch9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_lamb.call(this.lamb);
	lamb.x = 1000.25;
	lamb.y = 649.25;
	lamb.width = 393.50;
	lamb.height = 237.50;
	lamb.alpha = 1.00;
	if (lamb.onLayout) lamb.onLayout();
	const hollyFront = this.hollyFront;
	ch9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_hollyfront.call(this.hollyFront);
	hollyFront.x = 879.25;
	hollyFront.y = 555.5;
	hollyFront.width = 56.50;
	hollyFront.height = 54.00;
	hollyFront.alpha = 1.00;
	if (hollyFront.onLayout) hollyFront.onLayout();
	const frontSheep = this.frontSheep;
	ch9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_frontsheep.call(this.frontSheep);
	frontSheep.x = 786.5;
	frontSheep.y = 704;
	frontSheep.width = 1434.00;
	frontSheep.height = 128.00;
	frontSheep.alpha = 1.00;
	if (frontSheep.onLayout) frontSheep.onLayout();
	return this;
}
function ch9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_bg(this: Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p01_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_holly(this: Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p01_holly", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_fence(this: Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_fence) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p01_fence", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_hollymiddle(this: Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_hollymiddle) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p01_hollymiddle", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_lamb(this: Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_lamb) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p01_lamb", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_hollyfront(this: Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_hollyfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p01_hollyfront", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_frontsheep(this: Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_frontsheep) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p01_frontsheep", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich9_p01Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich9_p01Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich9_p01Sprite extends Ich9_p01Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich9_p01Text extends Ich9_p01Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich9_p01Polygon extends Array<number> {
}
interface Ich9_p01 {
	readonly bg: Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_bg;
	readonly hollyBack: Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_holly;
	readonly fence: Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_fence;
	readonly hollyMiddle: Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_hollymiddle;
	readonly lamb: Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_lamb;
	readonly hollyFront: Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_hollyfront;
	readonly frontSheep: Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_frontsheep;
}
interface Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_bg extends Ich9_p01Sprite {
}
interface Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_holly extends Ich9_p01Sprite {
}
interface Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_fence extends Ich9_p01Sprite {
}
interface Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_hollymiddle extends Ich9_p01Sprite {
}
interface Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_lamb extends Ich9_p01Sprite {
}
interface Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_hollyfront extends Ich9_p01Sprite {
}
interface Ich9_p01_hh_ch9_72dpi_p01psdAssetchp9_p01_frontsheep extends Ich9_p01Sprite {
}
